export const SET_FORM_LOADING = '@createVariant/SET_FORM_LOADING';
export const SET_FORM_DATA = '@createVariant/SET_FORM_DATA';
export const SET_NAME = '@createVariant/SET_NAME';
export const SET_TITLE = '@createVariant/SET_TITLE';
export const SET_DESCRIPTION = '@createVariant/SET_DESCRIPTION';
export const SET_PRODUCT_ID = '@createVariant/SET_PRODUCT_ID';
export const SET_QUANTITY_TYPE_ID = '@createVariant/SET_QUANTITY_TYPE_ID';
export const SET_FORM_TYPE_ID = '@createVariant/SET_FORM_TYPE_ID';
export const SET_MEAL_TYPE_ID = '@createVariant/SET_MEAL_TYPE_ID';
export const SET_CUISINE_TYPE_ID = '@createVariant/SET_CUISINE_TYPE_ID';
export const SET_TAX_TYPE_ID = '@createVariant/SET_TAX_TYPE_ID';
export const SET_IS_SPECIAL = '@createVariant/SET_IS_SPECIAL';
export const SET_IS_VEG = '@createVariant/SET_IS_VEG';
export const SET_IS_ACTIVE = '@createVariant/SET_IS_ACTIVE';
export const SET_SHELF_LIFE = '@createVariant/SET_SHELF_LIFE';
export const SET_SERVING = '@createVariant/SET_SERVING';
export const SET_HEATING_REQUIRED = '@createVariant/SET_HEATING_REQUIRED';
export const SET_QUANTITY_VALUE = '@createVariant/SET_QUANTITY_VALUE';
export const SET_PACKAGING_WEIGHT = '@createVariant/SET_PACKAGING_WEIGHT';
export const SET_IMAGE_PATH = '@createVariant/SET_IMAGE_PATH';
export const SET_SUBMIT_LOADING = '@createVariant/SET_SUBMIT_LOADING';



// WEBPACK FOOTER //
// ./src/Modules/CreateNewVariant/constants.js